module.exports = __webpack_public_path__ + "static/img/viral_16.67e084c4.jpg";